import { useQuery } from "@tanstack/react-query";
import { Api } from "@/api";
import { usersKeys } from "./keys";

/** Загружает собственные проекты выбранного пользователя для админки. */
export const useUserProjects = (id: string, enabled: boolean) => {
	const query = useQuery({
		queryFn: () => Api.User.getApiUsersProjectsById({ id }),
		queryKey: usersKeys.projects(id),
		enabled,
	});
	return { data: query.data?.data ?? [], isPending: query.isPending };
};
